import { render, staticRenderFns } from "./TextareaAutosize.vue?vue&type=template&id=bd203c30&"
import script from "./TextareaAutosize.vue?vue&type=script&lang=js&"
export * from "./TextareaAutosize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports